<template>
  <Drawer
    class="drawer_modal"
    width="700"
    v-model="showDrawer"
  >
    <supplierDetail
      v-if="showDetailComponent"
      :id="itemId"
      :base_view_url="base_view_url"
      :item_type="item_type"
      @click_cancel="cancelAction"
      @click_edit="editAction"
      @reload_table="$emit('reload-table')"
    ></supplierDetail>

    <supplierForm
      v-if="showFormComponent"
      v-model="itemId"
      :base_view_url="base_view_url"
      :action="itemAction"
      :item_type="item_type"
      @click_cancel="cancelAction"
      @show_detail="showDetail"
      @reload_table="$emit('reload-table')"
    ></supplierForm>
  </Drawer>
</template>

<script>
import { BaseItemData } from "../../base/base_item.js";

import supplierForm from "@/apps/supplier/supplierForm.vue";
import supplierDetail from "@/apps/supplier/supplierDetail.vue";

let _app = BaseItemData();
_app.components = {
  supplierDetail,
  supplierForm
};
_app.data = function() {
  return {
    titles: {
      detail: "Поставщик",
      edit: "Редактирование поставщика",
      create: "Создание поставщика"
    },
    itemAction: "detail",
    itemId: "",
    showDrawer: false
  };
};
export default _app;
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/apps/supplier/supplierItem.vue